import React, { useEffect } from 'react';

import { HorizontalStepper } from 'components/shared/stepper_horizontal';
interface CmdrsHorizontalStepperProps {
  activeStep: number;
  edit?: boolean;
  hasCmdrs?: boolean | null;
}

export const FormCmdrsHorizontalStepper: React.FC<
  CmdrsHorizontalStepperProps
> = ({ activeStep, edit, hasCmdrs }) => {
  const steps = hasCmdrs
    ? [
      'Informações sobre o CMDRS',
      'Membros',
      'Informações Complementares',
      'Desafios da agricultura familiar',
      'Demandas da agricultura familiar',
      ...(edit ? [] : ['Certificação / Identificação']),
    ]
    : [
      'Informações sobre o CMDRS',
      ...(edit ? [] : ['Certificação / Identificação']),
    ];


  useEffect(() => {
    centralizeActiveStep();
  }, [activeStep]);

  const centralizeActiveStep = () => {
    const stepperContainer = document.getElementById('cmdrs-stepper-container');
    const stepperSteps = stepperContainer?.querySelectorAll('.MuiStep-root');
    const activeStepElement = stepperSteps?.[activeStep - 1];

    if (
      stepperContainer instanceof HTMLElement &&
      activeStepElement instanceof HTMLElement
    ) {
      const containerWidth = stepperContainer.offsetWidth;
      const stepWidth = activeStepElement.offsetWidth;
      const offset = containerWidth / 2 - stepWidth / 2;
      stepperContainer.scrollLeft = activeStepElement.offsetLeft - offset;
    }
  };

  return (
    <HorizontalStepper id="cmdrs-stepper-container" steps={steps} activeStep={activeStep} edit={edit} />
  );

};
